import { render, staticRenderFns } from "./DomainStatic.vue?vue&type=template&id=a86e33d4&scoped=true&"
import script from "./DomainStatic.vue?vue&type=script&lang=js&"
export * from "./DomainStatic.vue?vue&type=script&lang=js&"
import style0 from "./DomainStatic.vue?vue&type=style&index=0&id=a86e33d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86e33d4",
  null
  
)

export default component.exports